import { Flex, Text, ActionIcon } from '@mantine/core';
import {
  IconArrowsSort,
  IconSortAscending,
  IconSortDescending,
} from '@tabler/icons-react';

export type CellSortProps = {
  label?: string;
  onSort?: (direction?: 'asc' | 'desc') => void;
  currentDirection?: 'asc' | 'desc';
};

export const CellSort = ({
  label,
  onSort,
  currentDirection,
}: CellSortProps) => {
  const handleClick = () => {
    if (!onSort) {
      return;
    }

    if (!currentDirection) {
      onSort('desc');
    } else if (currentDirection === 'desc') {
      onSort('asc');
    } else {
      onSort(undefined);
    }
  };

  const getSortIcon = () => {
    if (currentDirection === 'asc') {
      return <IconSortAscending size={20} />;
    }
    if (currentDirection === 'desc') {
      return <IconSortDescending size={20} />;
    }

    return <IconArrowsSort size={20} />;
  };

  return (
    <Flex
      align='center'
      gap={8}
      style={{ cursor: onSort ? 'pointer' : 'default' }}
    >
      <Text
        c='primary.7'
        size='sm'
        style={{
          fontWeight: 'bold',
        }}
      >
        {label}
      </Text>

      {onSort && (
        <ActionIcon
          size='sm'
          variant='subtle'
          onClick={handleClick}
          color={currentDirection ? 'blue' : 'gray'}
        >
          {getSortIcon()}
        </ActionIcon>
      )}
    </Flex>
  );
};
